<div class="face-detection-dialog">

    <!-- Header -->
    <div class="dialog-header">
      <div class="title-header">
        <div style="display: flex; flex-direction: row; align-items: center; cursor: pointer;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="onNoClick()">
              <path d="M15 18L9 12L15 6" stroke="#2D3036" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <h2 mat-dialog-title class="dialog-title" style="text-align: start;">{{'kyc.take_photo_face' | translate}}</h2>
        </div>
        <button type="button" class="close-btn" aria-label="Close" (click)="onNoClick()">
        <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <p class="note">
        {{'kyc.verification_face_note' | translate}}
      </p>
    </div>
  
    <!-- Body -->
    <div mat-dialog-content class="dialog-body">
        <div #sdkContainer id="sdk-container" style="width: 100%; height: 100%;"></div>
    </div>
  
    <!-- Footer -->
    <div mat-dialog-actions class="dialog-actions">
      <button type="button" class="btn btn-filled" (click)="onNoClick()">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.75 7.75L7.75 13.75M7.75 7.75L13.75 13.75M20.75 10.75C20.75 16.2728 16.2728 20.75 10.75 20.75C5.22715 20.75 0.75 16.2728 0.75 10.75C0.75 5.22715 5.22715 0.75 10.75 0.75C16.2728 0.75 20.75 5.22715 20.75 10.75Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{'kyc.close' | translate}}</span>
      </button>
    </div>
  
  </div>